const context: any = {};

export function makeContext(data: any, name: string): void {
  context[name] = data;
}

export function moduleContext(name: string): any {
  return context[name];
}

export function deleteContext(name: string): void {
  delete context[name];
}
